import Index from '@/views/index'
import jdyrole from '@/common/jdyrole';
export const system = {
  path: '/system',
  redirect: '/system/myhome',
  component: Index,
  name: 'system',
  meta: {
    requiresAuth: false
  },
  children: [{
    path: '/system/staffmessage',
    components: {
      default: () => import('@/views/system/staffManagement/staff-management')
    },
    name: 'staffmessage',
    meta: {
      title: '筋斗云-员工列表',
      requiresAuth: true,
      requiresRole: [jdyrole.superadmin, jdyrole.hr]
    }
  }, {
    path: '/system/serviceProvider',
    components: {
      default: () => import('@/views/system/serviceProvider/serviceProvider')
    },
    name: 'serviceProvider',
    meta: {
      title: '筋斗云-服务商管理',
      requiresAuth: true,
      requiresRole: [jdyrole.superadmin, jdyrole.hr]
    }
  }, {
    path: '/system/staffmessage/staffdetails',
    components: {
      default: () => import('@/views/system/staffManagement/staff-management-details')
    },
    name: 'staffdetails',
    meta: {
      title: '筋斗云-员工详情',
      requiresAuth: true,
      requiresRole: [jdyrole.superadmin, jdyrole.hr]
    }
  }, {
    path: '/system/channelmessage',
    components: {
      default: () => import('@/views/system/channel/channel-message')
    },
    name: 'channelmessage',
    meta: {
      title: '筋斗云-渠道管理',
      requiresAuth: true,
      requiresRole: [jdyrole.superadmin, jdyrole.hr]
    }
  }, {
    path: '/system/rolemessage',
    components: {
      default: () => import('@/views/system/role/role-message')
    },
    name: 'rolemessage',
    meta: {
      title: '筋斗云-角色管理',
      requiresAuth: true,
      requiresRole: [jdyrole.superadmin, jdyrole.hr]
    }
  }, {
    path: '/system/messagecenter',
    components: {
      default: () => import('@/views/system/messagecenter/index')
    },
    name: 'messagecenter',
    meta: {
      title: '筋斗云-通知函管理',
      requiresAuth: true,
      requiresRole: [jdyrole.superadmin, jdyrole.noticemanager]
    }
  }, {
    path: '/system/myhome',
    components: {
      default: () => import('@/views/system/myhome/')
    },
    name: 'myhome',
    hash: "#userMessage",
    meta: {
      title: '筋斗云-个人主页',
      requiresAuth: true,
      requiresRole: [jdyrole.superadmin, jdyrole.claimbiz, jdyrole.bizread, jdyrole.bizreadnoclaim, jdyrole.orderread, jdyrole.orderreadnoclaim, jdyrole.bizreadteam, jdyrole.claimbizbymanager
        , jdyrole.orderreadteam, jdyrole.ordermanager, jdyrole.biztransfer, jdyrole.projectmanager, jdyrole.projectread, jdyrole.projectreadteam, jdyrole.productmanager, jdyrole.hr, jdyrole.noticemanager]
    },
  }
  ]
}




// WEBPACK FOOTER //
// ./src/router/system/index.js